import { logDebug } from '../../shared/config/globalFunctions';
import {
  OBJECT_CLOSE_PROGRESS,
  OBJECT_DOWNLOAD_ERROR,
  OBJECT_DOWNLOAD_PROGRESS,
  OBJECT_FINISHED_DOWNLOAD,
  OBJECT_FINISHED_UPLOAD,
  OBJECT_START_DOWNLOAD,
  OBJECT_START_UPLOAD,
  OBJECT_UPLOAD_ERROR,
  OBJECT_UPLOAD_PROGRESS,
} from '../types/object';

/**
 * @typedef {import("../../../global").ObjectState} ObjectState
 * @typedef {import('../../../global').ObjectProgressStatus} ObjectProgressStatus
 * @typedef {import('../../../global').ObjectErrorStatus} ObjectErrorStatus
 */

/**
 * @type {ObjectState}
 */
const initialObjectState = {
  objectProgress: {},
  objectErrors: {},
};

/**
 *
 * @param {ObjectState} state the previous state
 * @param {{type: string, payload: ObjectProgressStatus | ObjectErrorStatus | any}} param1 payload and type
 * @returns {ObjectState}
 */
export const objectReducer = (
  state = initialObjectState,
  { type, payload }
) => {
  switch (type) {
    case OBJECT_CLOSE_PROGRESS: {
      return onObjectCloseProgress(payload, state);
    }
    /**
     * uploads
     */
    case OBJECT_START_UPLOAD: {
      return onObjectStartProgress(payload, state, 'upload');
    }
    case OBJECT_UPLOAD_PROGRESS: {
      return onObjectProgress(payload, state);
    }
    case OBJECT_FINISHED_UPLOAD: {
      return onObjectFinishedProgress(payload, state, 'upload');
    }
    case OBJECT_UPLOAD_ERROR: {
      return onObjectProgressError(payload, state);
    }
    /**
     * downloads
     */
    case OBJECT_START_DOWNLOAD: {
      return onObjectStartProgress(payload, state, 'download');
    }
    case OBJECT_DOWNLOAD_PROGRESS: {
      return onObjectProgress(payload, state);
    }
    case OBJECT_FINISHED_DOWNLOAD: {
      return onObjectFinishedProgress(payload, state, 'download');
    }
    case OBJECT_DOWNLOAD_ERROR: {
      return onObjectProgressError(payload, state);
    }
    default:
      return state;
  }
};

/**
 *
 * @param {ObjectProgressStatus} payload payload
 * @param {ObjectState} state state
 * @returns {ObjectState}
 */
function onObjectCloseProgress(payload, state) {
  logDebug('CLOSING PROGRESS FOR ', payload);
  logDebug('BEFORE', state.objectProgress);
  const objectData = payload;
  // we clear the progress key
  const { [objectData.guid]: _, ...otherProgress } = state.objectProgress;
  // we clear the error key
  const { [objectData.guid]: __, ...otherErrors } = state.objectErrors;
  logDebug('AFTER', otherProgress);
  return {
    ...state,
    objectProgress: otherProgress,
    objectErrors: otherErrors,
  };
}

/**
 *
 * @param {ObjectProgressStatus} payload payload
 * @param {ObjectState} state state
 * @returns {ObjectState}
 */
function onObjectFinishedProgress(payload, state, type) {
  const objectData = payload;
  const { [objectData.guid]: _, ...otherErrors } = state.objectErrors;
  return {
    ...state,
    objectProgress: {
      ...state.objectProgress,
      [objectData.guid]: {
        guid: objectData.guid,
        name: objectData.name,
        text: objectData.text,
        type: type,
        progress: 100,
      },
    },
    objectErrors: otherErrors,
  };
}

/**
 *
 * @param {ObjectProgressStatus} payload payload
 * @param {ObjectState} state state
 * @returns {ObjectState}
 */
function onObjectProgress(payload, state) {
  const progressData = payload;

  return {
    ...state,
    objectProgress: {
      ...state.objectProgress,
      [progressData.guid]: progressData,
    },
  };
}

/**
 *
 * @param {ObjectErrorStatus} payload payload
 * @param {ObjectState} state state
 * @returns {ObjectState}
 */
function onObjectProgressError(payload, state) {
  const objectErrors = payload;
  return {
    ...state,
    objectErrors: {
      ...state.objectErrors,
      [objectErrors.guid]: objectErrors,
    },
  };
}

/**
 *
 * @param {ObjectProgressStatus} payload payload
 * @param {ObjectState} state state
 * @returns {ObjectState}
 */
function onObjectStartProgress(payload, state, type) {
  const objectData = payload;
  // removing the key for this object
  const { [objectData.guid]: _, ...otherErrors } = state.objectErrors;
  return {
    ...state,
    // resetting progress to zero
    objectProgress: {
      ...state.objectProgress,
      [objectData.guid]: {
        guid: objectData.guid,
        name: objectData.name,
        text: objectData.text,
        type: type,
        progress: 0,
      },
    },
    // clearing errors for this object
    objectErrors: otherErrors,
  };
}
